module.exports = __webpack_public_path__ + "img/bavlogo.7c6fbcdf.png";